<template>
  <component :is="component" :value="modelValue" />
</template>

<script>
import Boat from './InsuredItem/Boat.vue';
import Car from './InsuredItem/Car.vue';
import Caravan from './InsuredItem/Caravan.vue';
import Construction from './InsuredItem/Construction.vue';
import Content from './InsuredItem/Content.vue';
import ExtendedTravel from './InsuredItem/ExtendedTravel.vue';
import Travel from './InsuredItem/Travel.vue';
import Health from './InsuredItem/Health.vue';
import House from './InsuredItem/House.vue';
import Moped from './InsuredItem/Moped.vue';
import Motorcycle from './InsuredItem/Motorcycle.vue';
import OtherVehicle from './InsuredItem/OtherVehicle.vue';
import PersonalAccident from './InsuredItem/PersonalAccident.vue';
import Pet from './InsuredItem/Pet.vue';
import SalaryProtection from './InsuredItem/SalaryProtection.vue';
import VacationHome from './InsuredItem/VacationHome.vue';
import Veteran from './InsuredItem/Veteran.vue';

export default {
  name: 'InsuredItem',
  components: {
    carComponent: Car,
    mopedComponent: Moped,
    motorcycleComponent: Motorcycle,
    healthComponent: Health,
    constructionComponent: Construction,
    boatComponent: Boat,
    caravanComponent: Caravan,
    veteranComponent: Veteran,
    contentComponent: Content,
    houseComponent: House,
    vacationHomeComponent: VacationHome,
    personalAccidentComponent: PersonalAccident,
    petComponent: Pet,
    salaryProtectionComponent: SalaryProtection,
    extendedTravelComponent: ExtendedTravel,
    travelComponent: Travel,
    otherVehicleComponent: OtherVehicle
  },
  props: {
    modelValue: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  computed: {
    component() {
      switch (this.modelValue.ProductType) {
        case 'boat':
          return 'boatComponent';
        case 'moped':
          return 'mopedComponent';
        case 'motorcycle':
          return 'motorcycleComponent';
        case 'health':
          return 'healthComponent';
        case 'car':
          return 'carComponent';
        case 'construction':
          return 'constructionComponent';
        case 'caravan':
          return 'caravanComponent';
        case 'veteran':
          return 'veteranComponent';
        case 'content':
          return 'contentComponent';
        case 'house':
          return 'houseComponent';
        case 'vacationHome':
          return 'vacationHomeComponent';
        case 'personalAccident':
          return 'personalAccidentComponent';
        case 'pet':
          return 'petComponent';
        case 'salaryProtection':
          return 'salaryProtectionComponent';
        case 'extendedTravel':
          return 'extendedTravelComponent';
        case 'travel':
          return 'travelComponent';
        case 'otherVehicle':
          return 'otherVehicleComponent';
        default:
          return ''; // TODO: is this the right default?
      }
    }
  }
};
</script>
